import React from "react";

export default function Stars(props) {
  let value = props.rating
  let maxRating = props.maxRating || 5
  let stars = []
  let full = Math.floor(value)
  for(let i=0; i < maxRating; i+=1) {
    let secondaryClass = 'empty'
    if(i <= full-1) {
      secondaryClass = '_100'
    }
    else {
      let rest = (value - i).toFixed(1)
      secondaryClass = `_${rest * 100}`
    }
    stars.push(<span key={i} className={`star ${secondaryClass}`} style={{fontSize:props.size}}>☆</span>)
  }

  return <div className="c-stars" title={`${value.toFixed(1)} / ${maxRating}`}>{stars}</div>
}

